<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12">
        <path
            fill="#8a8a94"
            fill-rule="evenodd"
            d="M10.2929.292893c.3905-.390524 1.0237-.390524 1.4142 0 .3905.390525.3905 1.023687 0 1.414217L7.41421 6l4.29289 4.2929c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0L6 7.41421 1.70711 11.7071c-.39053.3905-1.023693.3905-1.414217 0-.3905252-.3905-.3905252-1.0237 0-1.4142L4.58579 6 .292893 1.70711c-.3905241-.39053-.3905241-1.023693 0-1.414217.390524-.3905241 1.023687-.3905241 1.414217 0L6 4.58579z"
            clip-rule="evenodd"
        />
    </svg>
</template>
